import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Box, styled, Container, Typography, Grid, Hidden } from "@mui/material";

import packageJson from "../../../package.json";

const RootStyle = styled(Box)(({ theme }) => ({
  backgroundColor: "#FFF",
  minHeight: "calc(100vh - 120px)",
  margin: "0px auto",
  position: "relative",
  display: "flex",
  flexDirection: "column",
  maxHeight: '100vh',
  width: "100%",
}));

const OutletWrapper = styled(Box)(({ theme }) => ({
  margin: "0px",
  backgroundColor: "#FFF",
  width: "100%",
  overflowY: "auto",
  [theme.breakpoints.down(1200)]: {
    margin: "0px",
  },
  [theme.breakpoints.down("sm")]: {
    margin: "0px",
  },
  [theme.breakpoints.down("xs")]: {
    margin: "0px",
  },
}));

const ContainerPrincipal = styled(Grid)(({ theme }) => ({
  margin: "0px 45px 0px 0px",
  display: 'grid !important',
  gridTemplateColumns: '20% 60% 20%',
  gridAutoRows: '100vh !important',
  overflowY: 'hidden !important',
  '&::-webkit-scrollbar': {
    width: '0',
    background: 'transparent',
  },
  overflowX: 'hidden',
  position: 'fixed',
  top: 0,
  bottom: 0,
  width: '100%',
  [theme.breakpoints.only('xs')]: {
    gridTemplateColumns: '100%',
  },
  [theme.breakpoints.only('sm')]: {
    gridTemplateColumns: '10% 80% 10%',
  },
  [theme.breakpoints.only('md')]: {
    gridTemplateColumns: '15% 70% 15%',
  },
  [theme.breakpoints.only('lg')]: {
    gridTemplateColumns: '20% 60% 20%',
  },
  [theme.breakpoints.only('xl')]: {
    gridTemplateColumns: '20% 60% 20%',
  },
  background: "#f1f1f1"
}));

const LateralBox = styled(Box)(({ theme }) => ({
  background: "#f2f2f2",
  [theme.breakpoints.only('xs')]: {
    display: 'none'
  },
  [theme.breakpoints.only('sm')]: {
    display: 'block !important'
  },
  [theme.breakpoints.only('md')]: {
    display: 'block !important'
  },
  [theme.breakpoints.only('lg')]: {
    display: 'block !important'
  },
  [theme.breakpoints.only('xl')]: {
    display: 'block !important'
  },
}));


export const LoginLayout = () => {
  return (
    <ContainerPrincipal>
      <LateralBox />
      <RootStyle>
        <OutletWrapper>
          <Outlet />
        </OutletWrapper>
        <Box sx={{
          bottom: '0px',
          position: 'absolute',
          textAlign: 'center',
          flexDirection: 'column',
          display: 'flex',
          alignItems: 'center',
          zIndex: 20,
          height: '35px',
          backgroundColor: '#424242',
          width: '100%',
          color: '#FFF',
        }}>
          <Typography variant="h6" gutterBottom sx={{
            width: '100%',
            textAlign: 'center',
            paddingTop: '2px',
            letterSpacing: '0.53px',
            color: '#FFFFFF',
            opacity: '1',
            fontSize: '16px',
          }}
          >{packageJson.copyright} Versión: {packageJson.version}</Typography>
        </Box>
      </RootStyle>
      <LateralBox />
    </ContainerPrincipal>
  );
};
